import { StatementOfAccountsActionDispatch, StatementOfAccountsReduxTypes } from "./types";

export const createStatementOfAccounts= (payload : any):StatementOfAccountsActionDispatch=>({
    type:StatementOfAccountsReduxTypes.STATEMENT_OF_ACCOUNTS_REPORT,
    payload:payload
})